import React, { useState } from "react";
import useStyles from "../../components/Common/styles";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toastr } from "../../components/Common/toastr";
import { Blade, BladeValidationDisplay, BladeTabPanel } from "../../components/Common/Blade";
import { TextField, Tab, Tabs, Grid, Typography, Button } from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";
import { useForm } from "react-hook-form";
import useProtectApi from "../../hooks/useProtectApi";
import { useFetchInvestigationStatus } from "../../hooks/useFetchEntity";
import { DeleteButton } from "../../components/Common/Buttons";

const InvestigationStatusManage = () => {
	const [value, setValue] = React.useState(0);
	const [localInvestigationStatus] = useFetchInvestigationStatus();

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	function a11yProps(index) {
		return {
			id: `tab-${index}`,
			"aria-controls": `tabpanel-${index}`,
		};
	}
	return !localInvestigationStatus ? (
		<div></div>
	) : (
		<Blade>
			<Tabs
				value={value}
				onChange={handleChange}
				aria-label="user tabs"
				variant="fullWidth"
				indicatorColor="primary">
				<Tab label="Details" {...a11yProps(0)} />
				<Tab label="Remove" {...a11yProps(1)} />
			</Tabs>
			<BladeTabPanel value={value} index={0}>
				<InvestigationStatusDetails investigationStatus={localInvestigationStatus} />
			</BladeTabPanel>
			<BladeTabPanel value={value} index={1}>
				<RemoveInvestigationStatus investigationStatus={localInvestigationStatus} />
			</BladeTabPanel>
		</Blade>
	);
};

const InvestigationStatusDetails = ({ investigationStatus }) => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const renameInvestigationStatusApi = useProtectApi("investigationStatus/rename");
	const { register, handleSubmit, errors } = useForm();
	const history = useHistory();

	const [isBusy, setIsBusy] = useState(false);
	const [apiErrors, setApiErrors] = useState();

	const onSubmit = async (data) => {
		var request = {
			id: investigationStatus.id,
			name: data.name,
		};

		const renameInvestigationStatus = () =>
			renameInvestigationStatusApi.api().then((w) =>
				w
					.put(request)
					.badRequest((err) => {
						console.log(err);
						var errDetail = JSON.parse(err.text).detail;
						setApiErrors(errDetail);
						throw new Error(errDetail);
					})
					.error(409, (err) => {
						console.log(err);
						var errDetail = JSON.parse(err.text).detail;
						setApiErrors(errDetail);
						throw new Error(errDetail);
					})
					.json((json) => {
						var modifiedInvestigationStatus = {
							...request,
						};

						dispatch({
							type: "RENAME_INVESTIGATION_STATUS",
							payload: modifiedInvestigationStatus,
						});

						return modifiedInvestigationStatus;
					})
					.then(() => toastr.success("Investigation Status details changed"))
					.then(() => closeDrawer())
					.catch((error) => {
						console.log(error);
						toastr.error("Unable to change Investigation Status name.");
					})
					.finally(() => setIsBusy(false))
			);

		setIsBusy(true);
		renameInvestigationStatus();
	};

	const closeDrawer = () => {
		history.goBack();
	};

	return (
		<div>
			<form onSubmit={handleSubmit(onSubmit)}>
				<section>
					<TextField
						label="Name *"
						fullWidth
						autoFocus
						name="name"
						error={!!(errors && errors.name)}
						style={{ marginBottom: 16 }}
						autoComplete="off"
						inputRef={register({
							required: {
								value: true,
								message: "Name is required",
							},
							maxLength: {
								value: 255,
								message: "Name is too long",
							},
						})}
						inputProps={{
							"aria-label": "Name",
						}}
						helperText={errors && errors.name && errors.name.message}
						defaultValue={investigationStatus.name}
					/>
				</section>

				{!!apiErrors && <BladeValidationDisplay validationErrors={apiErrors} />}

				<div className={classes.drawerBladeToolbar}>
					<Button
						variant="contained"
						color="primary"
						size="medium"
						type="submit"
						className={classes.button}
						endIcon={<SaveIcon />}
						disabled={isBusy}>
						SAVE
					</Button>
				</div>
			</form>
		</div>
	);
};

const RemoveInvestigationStatus = ({ investigationStatus }) => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const history = useHistory();
	const removeInvestigationStatusApi = useProtectApi("investigationStatus/delete");
	const [isBusy, setIsBusy] = useState(false);
	const [apiErrors, setApiErrors] = useState();

	const closeDrawer = () => {
		history.goBack();
	};

	const removeInvestigationStatusClick = () => {
		var request = {
			Id: investigationStatus.id,
		};

		const apiDelete = () =>
			removeInvestigationStatusApi.api().then((w) =>
				w
					.put(request)
					.badRequest((err) => {
						console.log(err);
						var errDetail = JSON.parse(err.text).detail;
						setApiErrors(errDetail);
						throw new Error(errDetail);
					})
					.error(409, (err) => {
						console.log(err);
						var errDetail = JSON.parse(err.text).detail;
						setApiErrors(errDetail);
						throw new Error(errDetail);
					})
					.res(() => {
						dispatch({
							type: "REMOVE_INVESTIGATION_STATUS",
							payload: investigationStatus,
						});
					})
					.then(() => toastr.success("Investigation Status removed"))
					.then(() => closeDrawer())
					.catch((error) => {
						console.log(error);
						toastr.error("Unable to remove Investigation Status.");
					})
			);

		setIsBusy(true);
		apiDelete();
	};

	return (
		<div>
			<Typography>
				<p>Remove Investigation Status '{investigationStatus.name}' from the application?</p>
				<p>If you do so this Investigation Status will no longer be available.</p>
			</Typography>

			<div className={classes.drawerBladeToolbar}>
				<DeleteButton
					variant="outlined"
					color="primary"
					size="medium"
					onClick={() => removeInvestigationStatusClick()}
					className={classes.button}
					disabled={isBusy}
					text="Remove"
				/>
			</div>
			{!!apiErrors && <BladeValidationDisplay validationErrors={apiErrors} />}
		</div>
	);
};

export default InvestigationStatusManage;
